import gql from 'graphql-tag'

export const MAINTENANCE_NOTIFICATIONS_QUERY = gql`
    query MaintenanceNotifications {
        maintenanceNotifications(
            order: [{ field: DATE_FROM, direction: ASC }]
        ) {
            id
            type
            date_from
            date_until
        }
    }
`
